<template>
  <div>
    <nav v-if="$store.getters.isAuthenticated" data-cy="main-nav">
      <NavigationItem
        v-for="link of navLinks"
        :key="link.label"
        :linkData="link"
        @closeMenu="$emit('closeMenu')"
      />
    </nav>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import NavigationItem from './NavigationItem.vue'
import navLinks from './nav-links'

@Component({
  components: {
    NavigationItem
  }
})
export default class NavigationMenu extends Vue {
  navLinks = navLinks()
}
</script>

<style lang="scss" scoped>
nav {
  position: absolute;
  top: calc(#{$logo-container-height} + 40px);
  width: 290px;
}
</style>
